import { render, staticRenderFns } from "./QuotationListAgro.vue?vue&type=template&id=4fc915aa"
import script from "./QuotationListAgro.vue?vue&type=script&lang=js"
export * from "./QuotationListAgro.vue?vue&type=script&lang=js"
import style0 from "./QuotationListAgro.vue?vue&type=style&index=0&id=4fc915aa&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports